import Vue from "vue";
import Vuex from "vuex";
import apiService from "@/apiservice.js";
Vue.use(Vuex);

const state = {
    videoData: Array,
    pagesData: [],
    categories: [
        {
            ID: "ic",
            title: "iClone",
            link: "iclone",
            items: [
                {
                    type: "product-demo",
                    text: "Product Demo"
                },
                {
                    type: "media-buzz",
                    text: "Media Buzz"
                },
                {
                    type: "case-study",
                    text: "Case Study"
                },
                {
                    type: "feature-showcase",
                    text: "Featured Showcase"
                },
                {
                    type: "tutorials",
                    text: "Tutorials"
                },
                {
                    type: "content-trailers",
                    text: "Content Trailers"
                },
                {
                    type: "webinar",
                    text: "Webinar"
                }
            ]
        },
        {
            ID: "cc",
            title: "Character Creator",
            link: "character-creator",
            items: [
                {
                    type: "product-demo",
                    text: "Product Demo"
                },
                {
                    type: "feature-showcase",
                    text: "Featured Showcase"
                },
                {
                    type: "tutorials",
                    text: "Tutorials"
                },
                {
                    type: "content-trailers",
                    text: "Content Trailers"
                },
                {
                    type: "webinar",
                    text: "Webinar"
                }
            ]
        },
        {
            ID: "cta",
            title: "Cartoon Animator",
            link: "cartoon-animator",
            items: [
                {
                    type: "product-demo",
                    text: "Product Demo"
                },
                {
                    type: "media-buzz",
                    text: "Media Buzz"
                },
                {
                    type: "case-study",
                    text: "Case Study"
                },
                {
                    type: "feature-showcase",
                    text: "Featured Showcase"
                },
                {
                    type: "tutorials",
                    text: "Tutorials"
                },
                {
                    type: "content-trailers",
                    text: "Content Trailers"
                },
                {
                    type: "webinar",
                    text: "Webinar"
                }
            ]
        },
        {
            ID: "ct",
            title: "CrazyTalk",
            link: "crazytalk",
            items: [
                {
                    type: "product-demo",
                    text: "Product Demo"
                },
                {
                    type: "media-buzz",
                    text: "Media Buzz"
                },
                {
                    type: "case-study",
                    text: "Case Study"
                },
                {
                    type: "feature-showcase",
                    text: "Featured Showcase"
                },
                {
                    type: "tutorials",
                    text: "Tutorials"
                },
                {
                    type: "content-trailers",
                    text: "Content Trailers"
                },
                {
                    type: "webinar",
                    text: "Webinar"
                }
            ]
        },
        {
            ID: "3dx",
            title: "3DXchange",
            link: "3dxchange",
            items: [
                {
                    type: "product-demo",
                    text: "Product Demo"
                },
                {
                    type: "tutorials",
                    text: "Tutorials"
                }
            ]
        }
        // {
        //     ID: 'others',
        //     title: "Others",
        //     link: 'others',
        //     items: [
        //         {
        //             type: "product-demo",
        //             text: "Product Demo"
        //         }
        //     ]
        // }
    ],
    pageTypes: {
        "product-demo": "Product Demo",
        "media-buzz": "Media Buzz",
        "case-study": "Case Study",
        "feature-showcase": "Featured Showcase",
        "tutorials": "Tutorials",
        "content-trailers": "Content Trailers",
        "2d-live-show": "2D Live Show",
        "3d-live-show": "3D Live Show",
        "webinar": "Webinar"

    },
    categoryTypes: {
        "iclone": "iClone",
        "character-creator": "Character Creator",
        "cartoon-animator": "Cartoon Animator",
        "crazytalk": "CrazyTalk",
        "3dxchange": "3DXchange",
        "userStories": "User Stories"
    }
};
/*
    var Type = {
        ProductDemo: 0,
        MediaBuzz: 1,
        CaseStudy: 2,
        FeaturedMovie: 3,
        Tutorial: 4,
        ContentTrailer: 5,
        LiveShowFor2D: 6,
        LiveShowFor3D: 7
    }
 */
const actions = {
    getVideoData ({ commit }, params) {
        return new Promise((resolve, reject) => {
            apiService.ApiDataService.post(params, "ReallusionTV/v1/videos")
                .then(response => {
                    if (response.data.apiStatus == 2) {
                        commit("updateData", response);
                    } else {
                        reject();
                    }
                })
                .catch(error => {
                    reject();
            });
        });
    },
    getPagesData ({ commit }, params) {
        return new Promise((resolve, reject) => {
            apiService.ApiDataService.post(params, "ReallusionTV/v1/videos")
                .then(response => {
                    if (response.data.apiStatus == 2) {
                        resolve();
                        commit("updatePagesData", response);
                    } else {
                        reject();
                    }
                })
                .catch(error => {
                    reject();
            });
        });
    }
};

const mutations = {
    updateData: (state, payload) => {
        var tempData = [];
        for (var product = 0; product < payload.data.result.length; product++) {
            var productData = payload.data.result[product];
            for (var type = 0; type < productData.Info.length; type++) {
                var TypeData = productData.Info[type];
                TypeData.Data.sort(function (a, b) {
                    return new Date(b.CreateDate) - new Date(a.CreateDate);
                });
            }
        }

        if (payload.data.result.length > 0) {
            tempData[0] = payload.data.result[2];
            tempData[1] = payload.data.result[0];
            tempData[2] = payload.data.result[1];
        } else {
            tempData = payload.data.result;
        }

        state.videoData = tempData;
    },
    updatePagesData: (state, payload) => {
        let arr = [];
        payload.data.result.forEach(element => {
            arr.push(...element.Info[0].Data);
        });
        state.pagesData = arr;
    }
};

const getters = {
    videoData: function (state) {
        return state.videoData;
    },
    pagesData: function (state) {
        return state.pagesData;
    },
    categories: function (state) {
        return state.categories;
    },
    pageTypes: function (state) {
        return state.pageTypes;
    },
    categoryTypes: function (state) {
        return state.categoryTypes;
    }
};

export default new Vuex.Store({
    actions,
    state,
    mutations,
    getters
});



// WEBPACK FOOTER //
// ./src/store/index.js